export function mobileNav() {
    const toggleBtn = document.getElementById("toggleMobileNav");
    const nav = document.querySelector(".nav");
    const overlay = document.querySelector(".page-overlay");

    if (!toggleBtn || !nav || !overlay) return;

    function toggleNav() {
        const isActive = nav.classList.toggle("nav--active");
        overlay.classList.toggle("page-overlay--active", isActive);
        toggleBtn.classList.toggle("hamburger--active", isActive);
    }

    function closeNav(e) {
        if (
            nav.classList.contains("nav--active") &&
            !nav.contains(e.target) &&
            !toggleBtn.contains(e.target)
        ) {
            nav.classList.remove("nav--active");
            overlay.classList.remove("page-overlay--active");
            toggleBtn.classList.remove("hamburger--active");
        }
    }

    toggleBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        toggleNav();
    });

    document.addEventListener("click", closeNav);
}
